import { Col, Row } from 'antd'
import { FC } from 'react'
import LacquerType from '../../../../../../../components/form-items/lacquer-type/lacquer-type'
import Name from '../../../../../../../components/form-items/name/name'

interface LacquerProps {
    name: number
}

const Lacquer: FC<LacquerProps> = ({ name }) => {
    return (
        <Row gutter={24}>
            <Col sm={12}>
                <LacquerType namePath={name} />
            </Col>
            <Col sm={12}>
                <Name namePath={name} />
            </Col>
        </Row>
    )
}

export default Lacquer
